import {Alert, Button, Fade, IconButton, Snackbar} from "@mui/material";
import React from "react";
import {store} from "../../../helper/store";
import {clearNotification, pushNotification} from "../../../redux_actions/gamma.state.action";
import {CloseRounded} from "@mui/icons-material";
import {notNull} from "../../../utils/utils";
import {ErrorMessage, ErrorTypes} from "../../../utils/const";

const dispatchNotification = (notification) => {
	store.dispatch(pushNotification(notification));
}
export const closeNotification = (id) => store.dispatch(clearNotification(id));

/**
 *
 * @param id {string} - unique id for the notification
 * @param message {string} - message to display
 * @param severity {string} - severity of the notification
 * @param showClose {boolean} - show close button
 * @param autoHideDuration {int} in ms (default 5000) - set to 0 to disable auto hide
 * @param showReload {boolean} - show reload button
 * @param anchorOrigin {object} vertical and horizontal position of the notification
 * @param custom_icon custom icon to be displayed - false to disable icon
 */
const buildNotification = (id, message, severity, showClose, autoHideDuration, showReload = false, anchorOrigin, custom_icon) => {

	return <Snackbar id={id} key={id} open={true} sx={{mt: 4}} TransitionComponent={Fade}
					 anchorOrigin={anchorOrigin || {vertical: "top", horizontal: "right"}}
					 autoHideDuration={notNull(autoHideDuration) ? (autoHideDuration > 0 ? autoHideDuration : undefined) : 5000}
					 onClose={(event, reason) => {
						 if (reason === 'clickaway') {
							 return;
						 }
						 closeNotification(id)
					 }}
	>
		{notNull(custom_icon) ?
			<Alert severity={severity} icon={custom_icon} action={showClose ?
				<IconButton color={severity} onClick={() => closeNotification(id)}>
					<CloseRounded/>
				</IconButton> : showReload ?
					<Button color={severity} onClick={() => window.location.reload()} variant="outlined" size="small">
						Reload
					</Button> : null
			}>
				{message}
			</Alert> :
			<Alert severity={severity} action={showClose ?
				<IconButton color={severity} onClick={() => closeNotification(id)}>
					<CloseRounded/>
				</IconButton> : showReload ?
					<Button color={severity} onClick={() => window.location.reload()} variant="outlined" size="small">
						Reload
					</Button> : null
			}>
				{message}
			</Alert>}
	</Snackbar>
}

/**
 *
 * @param id {string} - unique id for the notification
 * @param message {string} - message to display
 * @param showClose {boolean} - show close button
 * @param autoHideDuration {int} in ms (default 5000) - set to 0 to disable auto hide
 * @param showReload {boolean} - show reload button
 * @param anchorOrigin {object} vertical and horizontal position of the notification
 * @param custom_icon custom icon to be displayed - false to disable icon
 */
export const notifySuccess = (id, message, showClose, autoHideDuration, showReload, anchorOrigin, custom_icon) =>
	dispatchNotification(buildNotification(id, message, "success", showClose, autoHideDuration, showReload, anchorOrigin, custom_icon));

/**
 *
 * @param id {string} - unique id for the notification
 * @param message {string} - message to display
 * @param showClose {boolean} - show close button
 * @param autoHideDuration {int} in ms (default 5000) - set to 0 to disable auto hide
 * @param showReload {boolean} - show reload button
 * @param anchorOrigin {object} vertical and horizontal position of the notification
 * @param custom_icon custom icon to be displayed - false to disable icon
 */
export const notifyInfo = (id, message, showClose, autoHideDuration, showReload, anchorOrigin, custom_icon) =>
	dispatchNotification(buildNotification(id, message, "info", showClose, autoHideDuration, showReload, anchorOrigin, custom_icon));

/**
 *
 * @param id {string} - unique id for the notification
 * @param message {string} - message to display
 * @param showClose {boolean} - show close button
 * @param autoHideDuration {int} in ms (default 5000) - set to 0 to disable auto hide
 * @param showReload {boolean} - show reload button
 * @param anchorOrigin {object} vertical and horizontal position of the notification
 * @param custom_icon custom icon to be displayed - false to disable icon
 */
export const notifyWarning = (id, message, showClose, autoHideDuration, showReload, anchorOrigin, custom_icon) =>
	dispatchNotification(buildNotification(id, message, "warning", showClose, autoHideDuration, showReload, anchorOrigin, custom_icon));

/**
 *
 * @param id {string} - unique id for the notification
 * @param message {string} - message to display
 * @param showClose {boolean} - show close button
 * @param autoHideDuration {int} in ms (default 5000) - set to 0 to disable auto hide
 * @param showReload {boolean} - show reload button
 * @param anchorOrigin {object} vertical and horizontal position of the notification
 * @param custom_icon custom icon to be displayed - false to disable icon
 */
export const notifyError = (id, message, showClose, autoHideDuration, showReload, anchorOrigin, custom_icon) =>
	dispatchNotification(buildNotification(id, message, "error", showClose, autoHideDuration, showReload, anchorOrigin, custom_icon));

export const notifyCustomErrors = (err, msg = "", showDuration = 5000) => {
	if ((err?.response?.status === 404 && (err?.response?.data.includes("nginx") &&
		err?.response?.data.includes(ErrorTypes.NGINX_ERROR))) || err?.response?.status === 500) {
		notifyError("merror", ErrorMessage.NGINX_ERROR, false, 0, true);
	} else if (err?.response?.status === 504) {
		notifyError("merror", ErrorMessage.SERVER_ERROR, false, 0, true);
	} else if (err?.response?.status === 403) {
		notifyError("uerror", ErrorMessage.UNAUTHORIZED_ERROR, false, showDuration);
	} else if (err?.response?.status === 502) {
		notifyError("bgerror", ErrorMessage.BAD_GATEWAY_ERROR, false, 0, true)
	} else if (err?.message === 'Network Error' || err?.code === 'ECONNABORTED') {
		notifyError("nerror", ErrorMessage.NETWORK_ERROR, false, showDuration)
	} else if (msg) {
		if (msg.includes(`<html>`)) msg = "Request failed";
		notifyError("customerror", msg, false, showDuration);
	} else if (typeof (err?.response?.data) === "object" && err.response.data.hasOwnProperty('ERRCODE') && err.response.data.hasOwnProperty('ERRMSG')) {
		const errMsg = "ERR - " + err.response.data['ERRCODE'] + " : " + err.response.data['ERRMSG'];
		notifyError("merror", errMsg, false, showDuration);
	}
}
